module.exports = __webpack_public_path__ + "img/pab.71d9109a.jpg";